export const defaultTranslations = require('./vernacularTexts.json');

export const defaultLanguage = {
  name: 'English',
  code: 'en'
};

export const hindi = {
  name: 'हिन्दी',
  code: 'hi'
};

export const languages = [
  defaultLanguage,
  hindi
];


let _selectedLanguageProvider;

export const setSelectedLanguageProvider = (provider) => {
  _selectedLanguageProvider = provider;
};

const LanguageCodeMap = {
  en: 'English',
  hi: 'Hindi'
};

export function langCodeToName(languageCode) {
  return LanguageCodeMap[languageCode] || languageCode || 'NA';
}

export const getSelectedLanguageCode = () =>
  (_selectedLanguageProvider && _selectedLanguageProvider().code) || 'NA';

export const getSelectedLanguageName = () =>
  (_selectedLanguageProvider && langCodeToName(_selectedLanguageProvider().code)) || 'NA';
